export function formatCheckoutProductText(value) {
  if (typeof value !== "string") return "";
  return value.replace(/\\n/g, "\n");
}

export function normalizeCheckoutProduct(product, prices = []) {
  const productData = product?.data;
  if (!product?.id || !productData?.active) return null;

  const price = prices.find(({ data }) => {
    return data?.active !== false && Number.isFinite(data?.unit_amount);
  });
  if (!price?.id) return null;

  const metadata = productData.metadata && typeof productData.metadata === "object"
    ? productData.metadata
    : {};

  return {
    id: product.id,
    data: {
      ...productData,
      description: formatCheckoutProductText(productData.description),
      images: Array.isArray(productData.images) ? productData.images : [],
      metadata: {
        ...metadata,
        extra_info: formatCheckoutProductText(metadata.extra_info),
      },
    },
    priceData: price,
  };
}
